var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export default {
    namespaced: true,
    state: {
        caseIds: [],
        userIds: [],
        deptIds: [],
        mode: "",
        category: "TO_COLLECTOR",
        debt: "NO",
        extData: {},
        personalCollectionDays: ''
    },
    getters: {
        perviewModel: function (state) {
            return __assign({ caseIds: state.caseIds, userIds: state.userIds, distributeCategory: "TO_COLLECTOR", commonFlag: "YES", distributeMode: state.mode, debt: state.debt, personalCollectionDays: state.personalCollectionDays }, state.extData);
        },
        distributeModel: function (state) {
            return __assign({ caseIds: state.caseIds, deptIds: state.deptIds, commonFlag: "YES", distributeCategory: state.category, distributeMode: state.mode, analyseId: "", distributeNumber: [], userIds: state.userIds, debt: state.debt, personalCollectionDays: state.personalCollectionDays }, state.extData);
        }
    },
    mutations: {
        /**
         * 更新分配类型
         * @param state
         * @param category 分配类型
         */
        updateCategory: function (state, allotType) {
            state.category = allotType;
        },
        updateMode: function (state, mode) {
            state.mode = mode;
        },
        updateDeptIds: function (state, deptId) {
            state.deptIds = [deptId];
        },
        updateUserIds: function (state, userIds) {
            state.userIds = userIds;
        },
        updateCaseIds: function (state, caseIds) {
            state.caseIds = caseIds;
        },
        updateDebtState: function (state, value) {
            state.debt = value ? "YES" : "NO";
        },
        // 额外的数据 eg:协催ID
        updateExtData: function (state, value) {
            state.extData = value;
        },
        updatePersonalCollectionDays: function (state, value) {
            state.personalCollectionDays = value;
        }
    },
    actions: {
        resetState: function (_a) {
            var commit = _a.commit;
            commit("updateCategory", "TO_COLLECTOR");
            commit("updateUserIds", []);
            commit("updateExtData", {});
            commit("updateMode", "BY_INTEGRATE");
        }
    }
};
